/* eslint-disable @typescript-eslint/naming-convention */
import { Button, Flex, Text } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import bgMetalPlates from "../assets/images/100-Extension-FWS1.png"
import bgBlanks from "../assets/images/accessories_blanks.png"
import bgExtensions from "../assets/images/accessories_extensions.png"
import bgPlasma from "../assets/images/accessories_plasma_templates.png"
import bgReducerRings from "../assets/images/accessories_reducer_rings.png"
import bgRepairKit from "../assets/images/accessories_repair_kit.png"
import bgTriplusSupportPlate from "../assets/images/accessories_triplus_support_plate.png"
import { COLLARTYPEKEY, FALLBACKIMAGES, Paths, breadCrumbFirstLevel, breadCrumbProductsSecondLevel } from "../common/commonConstants"
import { SimpleGridWrapper, SubPage, SubPageContent } from "../components/SubPage"
import { BannerType1 } from "../components/commons/bannerType1"
import { BreadCrumb } from "../components/commons/breadcrumb"
import { ProductThumbnailType3 } from "../components/commons/productThumbnailType3"
import { Colors } from "../theme/colors"
import { useAllCollarsQuery, type AllCollarsQuery, type Product4Menu } from "../type-and-hooks"

type AssociativeArray = Record<string, Product4Menu[]>

export const AllAccessories = (): JSX.Element => {
  const { data } = useAllCollarsQuery({ variables: { collarTypeId: COLLARTYPEKEY.ACCESSORIES }, fetchPolicy: "cache-and-network" })

  const navigate = useNavigate()
  const fallBackImage = FALLBACKIMAGES["150x150"]
  console.log(fallBackImage)

  const [allCollarsCategory, setAllCollarsCategory] = useState<AssociativeArray>({})

  const getSubCategoryData = (data: AllCollarsQuery): AssociativeArray => {
    const acc: AssociativeArray = {}
    data?.allCollars?.map(item => {
      const subCategory = item?.subcategory ?? "unknown"
      if (item) {
        acc[subCategory] = [...(acc[subCategory] ?? []), item]
      }
      return acc
    })

    return acc
  }

  useEffect(() => {
    if (data) {
      setAllCollarsCategory(getSubCategoryData(data))
    }
  }, [data])

  const handleClick = (item: string | undefined | null): void => {
    if (item) {
      void navigate(item ?? "/accessories", { state: { pid: item } })
      // navigate('/accessories/' + item.toLowerCase().replace(' ', '_'))
      // navigate('/products/accessories/product')
    } else {
      console.error("Product is not available", item)
    }
  }

  return (
    <SubPage>
      <BannerType1
        heading="All Accessories"
        image={bgMetalPlates}
        subText2Styles={{ marginTop: "59px" }}
        imageStyles={{ width: "380px", height: "330px" }}
      />
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          ...breadCrumbProductsSecondLevel,
          thirdLevel: { title: "Accessories" }
        }}
      />
      <Flex
        align={"center"}
        justify="center"
        flexDir={"column"}
        maxW={["328px", "328px", "328px", "580px", "580px", "580px"]}
        px={[0, 0, 0, 4, 4, 4]}
        margin={"auto"}
        mt="30px"
      >
        <Text align={"center"} textAlign={["left", "left", "left", "center", "center", "center"]}>
          Accessories come in a variety of sizes and products. They are able to enhance fire collars through extending or fastening the product.
        </Text>
        <Text variant="Body1Bold" color={Colors.Secondary.c2} my="23px" textAlign={["left", "left", "left", "center", "center", "center"]}>
          Select an accessory from below for further information.
        </Text>
        <Button
          onClick={() => {
            navigate(Paths.DISTRIBUTORS)
          }}
          variant={"Button1Regular"}
        >
          Buy From Distributor
        </Button>
      </Flex>
      <SubPageContent>
        <Flex overflow={"hidden"} mb="137px" justify={"center"}>
          <SimpleGridWrapper
            props={{
              columns: [1, 1, 1, 3, 3, 3],
              spacing: 3,
              padding: "32px 16px",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              spacingY: ["40px", "40px", "40px", "20px", "20px", "20px"]
            }}
          >
            {allCollarsCategory &&
              Object.entries(allCollarsCategory).map(([key, collars], index) => (
                <ProductThumbnailType3
                  key={key}
                  bg={
                    key.match(/^Blank/)
                      ? bgBlanks
                      : key.match(/Extension/)
                        ? bgExtensions
                        : key.match(/Plasma/)
                          ? bgPlasma
                          : key.match(/Reducer Ring/)
                            ? bgReducerRings
                            : key.match(/Repair Kit/i)
                              ? bgRepairKit
                              : key.match(/Triplus/)
                                ? bgTriplusSupportPlate
                                : key.match(/Metal/)
                                  ? bgMetalPlates
                                  : undefined
                  }
                  heading={key}
                  subText={`${collars.length ?? 0} items`}
                  onClickCallBack={() => {
                    handleClick(key.toLowerCase().replaceAll(" / ", "-").replaceAll(" - ", "-").replaceAll(" ", "-"))
                  }}
                />
              ))}
          </SimpleGridWrapper>
        </Flex>
      </SubPageContent>
    </SubPage>
  )
}
